import AddIcon from '@mui/icons-material/Add'
import CloseIcon from '@mui/icons-material/Close'
import { Dialog, Fab } from '@mui/material'
import { useContext, useEffect, useState } from 'react'
import { Spinner } from 'react-bootstrap'
import { useNavigate, useParams } from 'react-router-dom'
import { GenericHeaderBackButton } from 'src/consumer/components/UserActivityPage/MyPlanComponents'
import { CustomInput, CustomSelect, CustomTextArea, selectTypes } from 'src/consumer/components/helperComponents'
import { ROLE_TYPES } from 'src/consumer/constants'
import { ClinicDataContext } from 'src/context/ClinicDataContext'
import { sleep } from 'src/mentor/helpers/utilityFunctions'
import ClinicHeader from '../ClinicHeader'
import { HomePageItem } from '../ClinicHomePage/ClinicHomepageStyles'
import {
  AvailabilityPageContainer,
  ClinicTabButtonsContainer,
} from '../ClinicManageBookingsPage/ClinicManageBookingsPageStyles'
import { SatelliteChamberListingRow } from './SatelliteChamberStyle'

export default function SatelliteChamberPage() {
  const navigate = useNavigate()
  const { clinicId, clinicBrandId } = useParams()
  const { assistantData, ownerData, chosenRoleFlow, refreshOwnerAssociatedClinicChambersData } =
    useContext(ClinicDataContext)

  const [formDialogOpen, setFormDialogOpen] = useState(false)
  const [editedChamberData, setEditedChamberData] = useState({})

  let thisClinicData
  let chambersForThisClinic
  if (chosenRoleFlow === ROLE_TYPES.roleClinicOwner) {
    chambersForThisClinic = ownerData?.associatedClinicChambersData?.[clinicBrandId]?.filter(
      (item) => item?.clinicId === clinicId,
    )
    thisClinicData = ownerData?.associatedClinicsData?.find((item) => item?.id === clinicId)
  } else if (chosenRoleFlow === ROLE_TYPES.roleClinicAssistant) {
    chambersForThisClinic = assistantData?.associatedClinicChambersData?.filter(
      (item) => item?.clinicId === clinicId,
    )
    thisClinicData = assistantData?.associatedClinicsData?.find((item) => item?.id === clinicId)
  }

  function openChamberEditForm(existingChamberData) {
    setFormDialogOpen(true)
    setEditedChamberData(existingChamberData)
  }

  return (
    <AvailabilityPageContainer>
      <ClinicHeader
        heading={`Satellite Chamber: ${thisClinicData?.title}` || 'Choose a Satellite Chamber'}
      />
      <GenericHeaderBackButton
        clickfunction={() => window.history.back()}
        styles={{ margin: '20px' }}
      />
      <div>
        {chosenRoleFlow === ROLE_TYPES.roleClinicOwner ? (
          <ClinicChamberConfiguration
            allClinicChambersForThisClinic={chambersForThisClinic}
            ownerData={ownerData}
            clinicId={clinicId}
            clinicBrandId={clinicBrandId}
            clickFunction={(thisChamberData, ownerData) =>
              openChamberEditForm(thisChamberData, ownerData)
            }
          />
        ) : (
          <ClinicTabButtonsContainer>
            {chambersForThisClinic?.map((satelliteChamber, satelliteChamberIndex) => (
              <HomePageItem
                key={satelliteChamberIndex}
                onClick={() =>
                  navigate(
                    `/hotline-for-clinic-chamber/${clinicId}/${satelliteChamber?.satelliteScreenId}`,
                    { state: { satelliteChamber: satelliteChamber } },
                  )
                }
              >
                <div>{satelliteChamber?.title}</div>
              </HomePageItem>
            ))}
          </ClinicTabButtonsContainer>
        )}
      </div>
      <Dialog
        open={formDialogOpen}
        onClose={() => setFormDialogOpen(false)}
        PaperProps={{
          sx: { padding: '20px' },
        }}
      >
        <EditOrCreateChamberForm
          editedChamberData={editedChamberData}
          ownerData={ownerData}
          refreshOwnerAssociatedClinicChambersData={refreshOwnerAssociatedClinicChambersData}
          closeDialog={() => setFormDialogOpen(false)}
          clinicId={clinicId}
          clinicBrandId={clinicBrandId}
        />
      </Dialog>
    </AvailabilityPageContainer>
  )
}

const ClinicChamberConfiguration = ({
  allClinicChambersForThisClinic,
  ownerData,
  clinicId,
  clinicBrandId,
  clickFunction,
}) => {
  const thisClinicData = ownerData?.associatedClinicsData?.find((clinic) => clinic?.id === clinicId)
  const allMentors = ownerData?.ownerBrandMentorsData?.[clinicBrandId]
  const allApprovedUsers = ownerData?.ownerBrandPeopleUserSummary?.[clinicBrandId]

  return (
    <div style={{ minWidth: '500px', padding: '20px' }}>
      <SatelliteChamberListingRow isFirstRow>
        <div>
          <b>Title</b>
        </div>
        <div>
          <b>Mentor</b>
        </div>
        <div>
          <b>Assistant</b>
        </div>
        <div></div>
      </SatelliteChamberListingRow>
      {allClinicChambersForThisClinic?.map((chamberData, chamberIndex) => {
        const thisMentor = allMentors?.find((mentor) => mentor?.id === chamberData?.mentorId)
        const userIdOfThisAssistant = thisClinicData?.assistants?.find(
          (assistant) => assistant?.id === chamberData?.assistantId,
        )?.userId
        const thisAssistantUser = allApprovedUsers?.find(
          (user) => user?.userId === userIdOfThisAssistant,
        )

        return (
          <SatelliteChamberListingRow key={chamberIndex}>
            <div>{chamberData?.title || chamberData?.slug || chamberData?.id}</div>
            <div>
              {thisMentor
                ? thisMentor?.name || thisMentor?.firstName || thisMentor?.title
                : chamberData?.mentorId}
            </div>
            <div>
              {thisAssistantUser?.name || thisAssistantUser?.firstName || chamberData?.assistantId}
            </div>
            <div>
              <button
                style={{
                  padding: '2px 7px',
                  background: 'green',
                  fontWeight: '500',
                  color: '#fff',
                  borderRadius: '4px',
                }}
                onClick={() => clickFunction(chamberData)}
              >
                Edit
              </button>
            </div>
          </SatelliteChamberListingRow>
        )
      })}
      <div style={{ padding: '10px', display: 'flex', justifyContent: 'right' }}>
        <Fab
          size="small"
          onClick={() => clickFunction()}
          sx={{
            background: '#ffdf00',
            '&:hover': {
              background: '#ffdf99',
            },
          }}
        >
          <AddIcon />
        </Fab>
      </div>
    </div>
  )
}

const EditOrCreateChamberForm = ({
  editedChamberData,
  ownerData,
  refreshOwnerAssociatedClinicChambersData,
  closeDialog,
  clinicId,
  clinicBrandId,
}) => {
  const [saveLoading, setSaveLoading] = useState(false)
  const [localChamberData, setLocalChamberData] = useState()
  const [allAvailableAssistants, setAllAvailableAssistants] = useState([])
  const [allAvailableMentors, setAllAvailableMentors] = useState([])

  function setupThings() {
    if (editedChamberData) {
      setLocalChamberData({
        ...blankChamberData,
        ...editedChamberData,
        clinicId: clinicId,
        clinicBrandId: clinicBrandId,
      })
    } else {
      setLocalChamberData({ ...blankChamberData, clinicId: clinicId, clinicBrandId: clinicBrandId })
    }
  }

  async function saveFunction() {
    setSaveLoading(true)
    await sleep(500)
    // submit localChamberData here
    console.log(localChamberData)
    await refreshOwnerAssociatedClinicChambersData()
    setSaveLoading(false)
    closeDialog()
  }

  useEffect(() => {
    setupThings()
  }, [])

  useEffect(() => {
    const allAssistantsOfClinic = ownerData?.associatedClinicsData?.find(item => item?.id === clinicId)?.assistants || []
    const allApprovedAssistantsOfClinic = allAssistantsOfClinic?.filter(
      (assistant) => assistant?.id && assistant?.userId,
    )
    setAllAvailableAssistants(allApprovedAssistantsOfClinic)
    const allDoctorsOfClinic = ownerData?.associatedClinicsData?.find(item => item?.id === clinicId)?.doctors || []
    const allTherapistsOfClinic = ownerData?.associatedClinicsData?.find(item => item?.id === clinicId)?.therapists || []
    const allApprovedMentorsOfClinic = [...allDoctorsOfClinic, ...allTherapistsOfClinic]?.filter(
      (mentor) => mentor?.id && mentor?.userId,
    )
    setAllAvailableMentors(allApprovedMentorsOfClinic)
  }, [localChamberData])

  return (
    <div style={{ minWidth: '500px' }}>
      <div style={{ display: 'flex', justifyContent: 'right' }}>
        <CloseIcon style={{ cursor: 'pointer' }} onClick={closeDialog} />
      </div>
      <div style={{ fontSize: '20px', marginTop: '20px' }}>
        {editedChamberData ? 'Chamber Configuration' : 'New Chamber'}
      </div>
      <div style={{ width: '100%', height: '1px', background: '#cecece', margin: '10px 0' }}></div>
      <CustomInput
        label={'Title'}
        type="text"
        value={localChamberData?.title}
        onChange={(e) => setLocalChamberData((prev) => ({ ...prev, title: e.target.value }))}
      />
      <CustomTextArea
        label={'Description'}
        value={localChamberData?.description}
        onChange={(e) => setLocalChamberData((prev) => ({ ...prev, description: e.target.value }))}
      />
      <CustomSelect 
        id='assistant'
        label={'Assistant'}
        value={localChamberData?.assistantId}
        options={allAvailableAssistants}
        onChangeEvent={(e) => setLocalChamberData((prev) => ({...prev, assistantId: e.target.value }))}
        placeholder={'Select assistant'}
        selectType={selectTypes.string}
        getOptionValue={option => option?.id}
        getOptionLabel={option => option?.title || option?.id}
      />
      <CustomSelect 
        id='mentor'
        label={'Doctor/Therapist'}
        value={localChamberData?.mentorId}
        options={allAvailableMentors}
        onChangeEvent={(e) => setLocalChamberData((prev) => ({...prev, mentorId: e.target.value }))}
        placeholder={'Select one'}
        selectType={selectTypes.string}
        getOptionValue={option => option?.id}
        getOptionLabel={option => option?.title || option?.id}
      />
      <div style={{ width: '100%', height: '1px', background: '#cecece', margin: '10px 0' }}></div>
      <button
        style={{
          background: 'green',
          color: '#fff',
          fontWeight: '500',
          padding: '4px 8px',
          borderRadius: '4px',
        }}
        onClick={saveFunction}
      >
        {saveLoading ? <Spinner animation="border" variant="light" size="sm" /> : 'Save'}
      </button>
    </div>
  )
}

const blankChamberData = {
  apiParam: 'clinic-chamber',
  assistantId: '',
  clinicBrandId: '',
  clinicId: '',
  description: '',
  id: '',
  mentorId: '',
  satelliteScreenId: '',
  slug: '',
  title: '',
}
